import { environment } from "../../environments/environment";

export function assert(condition, ...msg): void {
    if (!condition) {
        if (environment.production) {
            console.error("BUG:", ...msg);
        } else {
            //throw new Error(`BUG: ${msg}`)
            console.error("BUG:", ...msg);
        }
    }
}
